import { gql } from '@apollo/client';

export const UPDATE_VENDOR = gql`
  mutation UpdateVendor($vendor: UpdateVendorInput!, $vendorId: ID!) {
    updateVendor(vendor: $vendor, vendorId: $vendorId) {
      contactInfo {
        city
        country
        state
        street
        zip
      }
      email
      firstName
      lastName
      paperWorkFinished
      phone
      vendorName
    }
  }
`;
